import { cloneElement } from 'react'
import {
  useEditController,
  EditContextProvider,
  Loading,
  useNotify,
} from 'react-admin'

import { Relationships } from '../../../data'

const CustomBirdEdit = (props) => {
  const controllerProps = useEditController(props)

  const {
    loading,
    record,
    setTransform,
    hasCreate,
    hasShow,
    hasList,
    hasEdit,
    setOnFailure,
    setOnSuccess,
    transformRef,
    onFailureRef,
    onSuccessRef,
    defaultTitle,
    ...other
  } = controllerProps

  const notify = useNotify()
  const transform = async (data) => {
    const fallback = Object.assign({}, data)
    delete fallback.allBirds
    delete fallback.similarBirds
    delete fallback.mapImages
    delete fallback.thumbnailImage
    delete fallback.galleryImages
    delete fallback.sounds
    delete fallback.videos
    delete fallback.idPointImages
    delete fallback.modelFiles
    if (fallback.region && fallback.region[0] === null) fallback.region = null
    try {
      return await Relationships.transformData('bird', data, record)
    } catch (error) {
      console.error('[CustomBirdEdit] transform error:', error)
      notify(error.message || 'ra.notification.http_error', 'error')
      return fallback
    }
  }
  setTransform(transform)

  if (loading) {
    return <Loading />
  }

  return (
    <EditContextProvider value={controllerProps}>
      <div>
        {cloneElement(props.children, {
          record,
          ...other,
        })}
      </div>
    </EditContextProvider>
  )
}

export default CustomBirdEdit
